"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SUBSCRIPTION_LEVELS = exports.NotifyFor = void 0;
var NotifyFor;
(function (NotifyFor) {
    NotifyFor["All"] = "all";
    NotifyFor["SubscribedOnly"] = "subscribedOnly";
})(NotifyFor || (exports.NotifyFor = NotifyFor = {}));
exports.DEFAULT_SUBSCRIPTION_LEVELS = ['all', 'none'];
//# sourceMappingURL=shared.type.js.map